export default "__VITE_ASSET__B8VCiCwG__"